import { trackEvent } from 'lib/tracking';
import { useEffect, useState } from 'react';

type UsePageViewResult = {
  pageViewEventSent: boolean;
};
export const usePageView = (event: any): UsePageViewResult => {
  const [pageViewEventSent, setPageViewEventSent] = useState(false);
  useEffect(() => {
    void trackEvent(event).finally(() => setPageViewEventSent(true));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return { pageViewEventSent };
};
